import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import suicide from "../../Assets/Projects/suicide.png";
import paymentimage from "../../Assets/Projects/payment.png";
import paymentimage2 from "../../Assets/Projects/payment2.png";
import paymentimage3 from "../../Assets/Projects/payment3.png";
import paymentimage4 from "../../Assets/Projects/payment4.png";
import paymentimage5 from "../../Assets/Projects/payment5.png";
import paymentimage6 from "../../Assets/Projects/payment6.png";
import game1 from "../../Assets/Projects/game1.png";
import game2 from "../../Assets/Projects/game2.png";
import game3 from "../../Assets/Projects/game3.png";
import game4 from "../../Assets/Projects/game4.png";
import game5 from "../../Assets/Projects/game5.png";
import game6 from "../../Assets/Projects/game6.png";
import game7 from "../../Assets/Projects/game7.png";
import app1 from "../../Assets/Projects/1.png"
import app2 from "../../Assets/Projects/2.png"
import app3 from "../../Assets/Projects/3.png"
import app4 from "../../Assets/Projects/4.png"
import app5 from "../../Assets/Projects/5.png"
import app6 from "../../Assets/Projects/6.png"
import oldPortfolio from "../../Assets/Projects/oldPortfolio.png";
const gameImageArray=[game1,game2,game3,game4,game5,game6,game7];
const imageArray=[paymentimage,paymentimage2,paymentimage3,paymentimage4,paymentimage5,paymentimage6];
const appArray=[app1,app2,app3,app4,app5,app6];
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Featured <strong className="purple">Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          A selection of my recent and past work.
        </p>

        {/* iOS Apps Section */}
        <h2 className="project-sub-heading" style={{ color: "#c084fc", fontSize: "1.5em", marginTop: "30px", marginBottom: "20px" }}>
          📱 iOS Apps (App Store)
        </h2>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={null}
              isBlog={false}
              onlyDemo={true}
              isAppStore={true}
              title="Agentury AI"
              description="A multi-model AI chat app supporting OpenAI GPT-4o, Anthropic Claude, Google Gemini, and DeepSeek. Features built-in job hunting assistants (Resume Writer, Interview Coach, Cover Letter Writer, LinkedIn Optimizer) with document upload for resume analysis. Users bring their own API keys."
              appStoreLink="https://apps.apple.com/app/agentury-ai"
              techTags={["Swift", "SwiftUI", "OpenAI API", "Claude API", "Gemini API", "PDFKit"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={null}
              isBlog={false}
              onlyDemo={true}
              isAppStore={true}
              title="StockPulse AI"
              description="AI-powered stock analysis app with real-time market data, intelligent stock screening, and AI-driven insights. Features include watchlists, portfolio tracking, and subscription-based premium analytics with in-app purchases."
              appStoreLink="https://apps.apple.com/app/stockpulse-ai"
              techTags={["Swift", "SwiftUI", "StoreKit 2", "REST API", "Charts"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={null}
              isBlog={false}
              onlyDemo={true}
              isAppStore={true}
              title="TimelineNote"
              description="A beautiful timeline-based note-taking app with AI-powered summarization, iCloud sync, rich categorization, and multi-language support (18 languages). Features dark mode, data export, and notification reminders."
              appStoreLink="https://apps.apple.com/app/timelinenote"
              techTags={["Swift", "SwiftData", "CloudKit", "Kimi AI", "Localization"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={null}
              isBlog={false}
              onlyDemo={true}
              isAppStore={true}
              title="TimelessDialogue (时空对话)"
              description="Chat with historical figures powered by AI. Engage in conversations with Confucius and other sages from ancient China. Features a Cloudflare Worker backend proxy with daily free quota system and streaming responses."
              appStoreLink="https://apps.apple.com/app/timelessdialogue"
              techTags={["Swift", "SwiftUI", "DeepSeek API", "Cloudflare Workers", "SSE Streaming"]}
            />
          </Col>
        </Row>

        {/* Web & ML Projects Section */}
        <h2 className="project-sub-heading" style={{ color: "#c084fc", fontSize: "1.5em", marginTop: "30px", marginBottom: "20px" }}>
          🌐 Web & ML Projects
        </h2>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gameImageArray}
              isBlog={false}
              onlyDemo={false}
              title="Game Image Design (GAN + CNN)"
              description="Deep learning image generation system leveraging Generative Adversarial Networks and Convolutional Neural Networks. Trained on 10,000 game images with user-driven image synthesis capabilities."
              ghLink="https://github.com/XuchenSun/Game-Image-Design-Based-On-GAN-and-CNN"
              demoLink="https://www.youtube.com/watch?v=PF16ie9bQdQ"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={imageArray}
              isBlog={false}
              title="PaymentPro"
              description="A versatile payment processing template built with HTML, CSS, and JavaScript. Modular solution easily integrated into React, Angular, Java, PHP, and Python stacks."
              onlyDemo={false}
              ghLink="https://github.com/XuchenSun/projects/tree/main/payment"
              demoLink="https://xuchensun.github.io/projects/payment/payment-landing.html"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={appArray}
                isBlog={false}
                onlyDemo={true}
                title="OpenUV"
                description="A sci-fi-themed weather app with real-time data and location-based forecasting. Built with React Native and Expo, deployed on Cloudflare Pages."
                websiteLink="https://openuv.pages.dev/"
                demoLink="https://xuchensun.com/openuv/video.mp4"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={oldPortfolio}
              isBlog={false}
              title="Previous Portfolio"
              description="Earlier portfolio showcasing AWS, Terraform, ML, and hardware design projects. Demonstrates full-stack development and DevOps practices."
              ghLink="https://github.com/XuchenSun/html"
              demoLink="https://xuchensun.github.io/html/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
